import React from "react";
import Reveal from "./Reveal";
import imgCampo from "../assets/images/7.jpeg";
import imgParques from "../assets/images/6.jpeg";
import imgDeportivo from "../assets/images/12.jpeg";

const sectors = [
  {
    title: "Campo",
    image: imgCampo,
    alt: "Pivote central regando un cultivo de caña de azúcar junto a un camino de tierra",
    text: "Pivotes centrales, alas regadoras y equipos de aspersión para producción agrícola y ganadera.",
  },
  {
    title: "Parques y jardines",
    image: imgParques,
    alt: "Aspersores emergentes regando el parque de una casa quinta",
    text: "Riego automatizado para casas quintas, countries, plazas y espacios verdes públicos.",
  },
  {
    title: "Deportivo",
    image: imgDeportivo,
    alt: "Línea de aspersores regando una cancha deportiva",
    text: "Canchas de fútbol, golf y polo: cobertura pareja y programación automática.",
  },
];

const Sectors = () => {
  return (
    <section id="sectores" className="py-20 sm:py-28">
      <div className="container-site">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="section-eyebrow">Dónde trabajamos</p>
          <h2 className="section-title">Tres sectores, una misma exigencia</h2>
          <p className="section-lead">
            Cada terreno tiene su lógica. Adaptamos el equipo, la presión y el
            caudal a lo que realmente necesita el suelo.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {sectors.map((sector, i) => (
            <Reveal key={sector.title} delay={i * 90}>
              <article className="group relative h-[420px] overflow-hidden rounded-2xl shadow-card">
                <img
                  src={sector.image}
                  alt={sector.alt}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />

                <div
                  className="absolute inset-0 bg-gradient-to-t from-campo-950 via-campo-950/45 to-transparent"
                  aria-hidden="true"
                />

                <div className="absolute inset-x-0 bottom-0 p-7">
                  <h3 className="text-2xl text-white">{sector.title}</h3>
                  {/* En desktop el texto aparece al pasar el mouse; en touch siempre visible. */}
                  <p className="mt-2 text-sm leading-relaxed text-campo-100 md:max-h-0 md:overflow-hidden md:opacity-0 md:transition-all md:duration-500 md:group-hover:max-h-40 md:group-hover:opacity-100">
                    {sector.text}
                  </p>
                  <span
                    className="mt-4 block h-0.5 w-12 rounded-full bg-campo-400 transition-all duration-500 group-hover:w-20"
                    aria-hidden="true"
                  />
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sectors;
